"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommandingPresenceAbilityHandler = exports.CommandingPresenceActorAbilityFactory = exports.CommandingPresenceAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Duration_1 = require("../../core/Duration");
const Passive_CommandingPresence_1 = require("../../core/effects/core/Passive_CommandingPresence");
class CommandingPresenceAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CommandingPresence;
        this.__typeName = "CommandingPresence";
    }
}
exports.CommandingPresenceAbilityArgs = CommandingPresenceAbilityArgs;
let CommandingPresenceActorAbilityFactory = class CommandingPresenceActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CommandingPresence", "Self", 0);
    }
};
CommandingPresenceActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CommandingPresence")
], CommandingPresenceActorAbilityFactory);
exports.CommandingPresenceActorAbilityFactory = CommandingPresenceActorAbilityFactory;
let CommandingPresenceAbilityHandler = class CommandingPresenceAbilityHandler {
    init(sequence, container, actorId) {
        container.applyBuff({
            sequence,
            creatorId: actorId,
            targetId: actorId,
            duration: Duration_1.Duration.Permanent,
            effect: new Passive_CommandingPresence_1.Passive_CommandingPresenceEffectArgs(),
            supernatural: true
        });
    }
    activate(sequence, container, ability) {
        throw new Error("PASSIVE_ONLY");
    }
};
CommandingPresenceAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CommandingPresence)
], CommandingPresenceAbilityHandler);
exports.CommandingPresenceAbilityHandler = CommandingPresenceAbilityHandler;
